export default __webpack_public_path__ + "static/media/Sume_Premio_Transito_blanco.ac09a411.png";